import { render, staticRenderFns } from "./CreateCapacity.vue?vue&type=template&id=27baefcf"
import script from "./CreateCapacity.vue?vue&type=script&lang=js"
export * from "./CreateCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports